export const actionKey = '@@DreamupShared';

//# sourceMappingURL=constants.js.map